import {FormControl} from '@angular/forms';

export function compare(otherControlName: string, greaterThan) {
  let thisControl: FormControl;
  let otherControl: FormControl;
  return function matchOtherValidate(control: FormControl) {
    if (!control.parent) {
      return null;
    }
    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as FormControl;
      otherControl.valueChanges.subscribe(() => {
        thisControl.updateValueAndValidity();
      });
    }
    if (otherControl.value && !greaterThan) {
      if (otherControl.value < thisControl.value) {
        return {
          lessThan: true
        };
      }
    }
    if (otherControl.value && greaterThan && (thisControl.value || thisControl.value === 0)) {
      if (otherControl.value > thisControl.value) {
        return {
          lessThan: true
        };
      }
    }
    return null;
  };
}

export enum applicationStatus {
  LOAN_DETAILS, //0
  USER_BASIC_DETAILS, //1
  RESIDENCE_DETAILS, //2
  CIBIL_APPLIED, //3
  CIBIL_PROGRESS, //4
  CIBIL_APPROVED, //5
  CUSTOMER_INIT, //6
  PAYMENT_DONE, //7
  ENACH_ENABLED, //8
  APPLICATION_SUBMITTED, //9
  DISBURSED, //10
  REJECTED, //11
  CANCELLED //12
}
